export const toggleInArray = function <T>(value: T, array: T[]): T[] {
    return array.includes(value) ? array.filter((item) => value !== item) : [...array, value];
};
